// extracted by mini-css-extract-plugin
module.exports = {"form":"Auctions-subscribe_form__bSjGs"};